import { inject, Injectable } from '@angular/core';
import { FilterStore } from './filter.store';
import { Filter, FilterOption } from '../../domain/interfaces/Filter.interface';

@Injectable({
  providedIn: 'root'
})
export class FilterValidateService {
  private readonly store = inject(FilterStore)

  validateFilter(filter: Filter): Filter {
    const validatedFilter = { ...filter };

    if (validatedFilter.states?.length) {
      validatedFilter.states = this.validateStates(
        validatedFilter.states,
        this.store.states()
      )
    }

    if (validatedFilter.municipalities?.length) {
      validatedFilter.municipalities = this.validateMunicipalities(
        validatedFilter.municipalities,
        this.store.municipalities()
      )
    }

    if (validatedFilter.indigenousLands?.length) {
      validatedFilter.indigenousLands = this.validateIndigenousLands(
        validatedFilter.indigenousLands,
        this.store.indigenousLands()
      )
    }

    if (validatedFilter.conservationUnits?.length) {
      validatedFilter.conservationUnits = this.validateConservationUnits(
        validatedFilter.conservationUnits,
        this.store.conservationUnits()
      )
    }

    if (validatedFilter.specialTerritories?.length) {
      validatedFilter.specialTerritories = this.validateSpecialTerritories(
        validatedFilter.specialTerritories,
        this.store.specialTerritories()
      )
    }

    if (validatedFilter.status?.length) {
      validatedFilter.status = this.validateStatus(
        validatedFilter.status,
        this.store.status()
      )
    }

    if (validatedFilter.connectionType?.length) {
      validatedFilter.connectionType = this.validateConnectionType(
        validatedFilter.connectionType,
        this.store.connectionType()
      )
    }

    if (validatedFilter.partners?.length) {
      validatedFilter.partners = this.validatePartner(
        validatedFilter.partners,
        this.store.partners()
      )
    }

    if (validatedFilter.energyKitModel?.length) {
      validatedFilter.energyKitModel = this.validateEnergyKitModel(
        validatedFilter.energyKitModel,
        this.store.energyKitModel()
      )
    }

    if (validatedFilter.declaredTerritory?.length) {
      validatedFilter.declaredTerritory = this.validateDeclaredTerritory(
        validatedFilter.declaredTerritory,
        this.store.declaredTerritory()
      )
    }

    if (validatedFilter.workGroups?.length) {
      validatedFilter.workGroups = this.validateWorkGroups(
        validatedFilter.workGroups,
        this.store.workGroups()
      )
    }

    if (validatedFilter.routerModel?.length) {
      validatedFilter.routerModel = this.validateRouterModel(
        validatedFilter.routerModel,
        this.store.routerModel()
      )
    }

    return validatedFilter;
  }

  validateStates(selected: any[], available: any[]): any[] {
    if (!selected?.length) return [];
    return selected.filter(item =>
      available.some(option =>  option.id === item.id)
    )
  }

  validateMunicipalities(selected: any[], available: any[]): any[] {
    if (!selected?.length) return [];
    return selected.filter(item =>
      available.some(option => option.id === item.id)
    )
  }

  validateIndigenousLands(selected: any[], available: any[]): any[] {
    if (!selected?.length) return [];
    return selected.filter(item =>
      available.some(option => option.id === item.id)
    )
  }

  validateConservationUnits(selected: any[], available: any[]): any[] {
    if (!selected?.length) return [];
    return selected.filter(item =>
      available.some(option =>
        option.id === item.id &&
        option.category === item.category
      )
    )
  }

  validateSpecialTerritories(selected: any[], available: any[]): any[] {
    if (!selected?.length) return [];
    return selected.filter(item =>
      available.some(option =>
        option.id === item.id &&
        option.category === item.category
      )
    )
  }

  validateStatus(selected: any[], available: any[]): any[] {
    if (!selected?.length) return [];
    return selected.filter(item =>
      available.some(option => option.id === item.id)
    )
  }

  validateContractType(selected: any[], available: any[]): any[] {
    if (!selected?.length) return [];
    return selected.filter(item =>
      available.some(option => option.id === item.id)
    )
  }

  validateConnectionType(selected: any[], available: any[]): any[] {
    if (!selected?.length) return [];
    return selected.filter(item =>
      available.some(option => option.id === item.id)
    )
  }

  validatePartner(selected: any[], available: any[]): any[] {
    if (!selected?.length) return [];
    return selected.filter(item =>
      available.some(option => option.id === item.id)
    )
  }

  validateEnergyKitModel(selected: any[], available: any[]): any[] {
    if (!selected?.length) return [];
    return selected.filter(item =>
      available.some(option => option === item)
    )
  }

  validateDeclaredTerritory(selected: any[], available: any[]): any[] {
    if (!selected?.length) return [];
    return selected.filter(item =>
      available.some(option => option.id === item.id)
    )
  }

  validateWorkGroups(selected: any[], available: any[]): any[] {
    if (!selected?.length) return [];
    return selected.filter(item =>
      available.some(option => option.id === item.id)
    )
  }

  validateRouterModel(selected: any[], available: any[]): any[] {
    if (!selected?.length) return [];
    return selected.filter(item =>
      available.some(option => option.id === item.id)
    )
  }
}
